import React from 'react';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white dark:bg-[#171717] py-12 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Logo with dark/light mode support */}
        <div className="flex justify-center mb-8">
          <img 
            src="/logo-only200-removebg.png"
            alt="PowerAI Logo"
            className="h-16 w-auto block dark:hidden" // Show in light mode
          />
          <img 
            src="/logo-only200-removebg-inverted.png"
            alt="PowerAI Logo"
            className="h-16 w-auto hidden dark:block" // Show in dark mode
          />
        </div>

        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-green-100 dark:bg-green-900 p-3">
              <svg className="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl mb-4">
            Thank You for Your Payment!
          </h2>
          <p className="text-xl text-gray-500 dark:text-gray-400 mb-8">
            Your subscription has been successfully processed.
          </p>
          <button
            onClick={handleContinue}
            className="inline-block px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-center font-medium shadow-lg hover:shadow-xl"
          >
            Continue to Dashboard
          </button>
        </div>

        <div className="bg-gray-50 dark:bg-[#202123] rounded-2xl shadow-lg p-8">
          <div className="text-gray-700 dark:text-gray-300">
            <h3 className="text-xl font-semibold mb-4">What's Next?</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span>Your account has been credited with 5,000 message credits</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span>You now have access to all premium features</span>
              </li>
              <li className="flex items-start">
                <svg className="w-6 h-6 text-green-500 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                <span>Your subscription will automatically renew next month</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou; 